<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      scrollable
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
        <span> {{ $t("Ticket") }}</span>
        <span v-if="isUpdated">{{ form.subject }}</span>
      </template>
      <b-form>
        <b-row>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Subject')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Subject')"
                vid="subject"
                rules="required"
              >
                <b-form-input
                  id="subject"
                  v-model="form.subject"
                  type="text"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Subject')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Category')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Category')"
                vid="category"
                rules="required"
              >
                <v-select
                  v-model="form.category"
                  :options="additionalData.categories"
                  :clearable="false"
                  :reduce="category => category.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Priority')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Priority')"
                vid="priority"
                rules="required"
              >
                <v-select
                  v-model="form.priority"
                  :options="additionalData.priorities"
                  :clearable="false"
                  :reduce="priority => priority.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="$can('update','tickets')"
            md="6"
            cols="12"
          >
            <b-form-group :label="$t('Status')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Status')"
                vid="status"
                rules="required"
              >
                <v-select
                  v-model="form.status"
                  :options="additionalData.statuses"
                  :clearable="false"
                  :reduce="_status => _status.key"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="$can('update','tickets')"
            cols="12"
            md="6"
          >
            <b-form-group :label="$t('User')">
              <validation-provider
                #default="{ errors }"
                :name="$t('User')"
                vid="user_id"
                rules="required"
              >
                <select-user
                  :label="$t('User')"
                  :value="form.user_id"
                  name="user_id"
                  :state="errors.length > 0 ? false : null"
                  @onModelChange="(name,value) => form.user_id = value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="$can('update','tickets')"
            cols="12"
            md="6"
          >
            <b-form-group :label="$t('Agent')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Agent')"
                vid="agent_id"
                rules="required"
              >
                <select-user
                  :label="$t('Agent')"
                  :value="form.agent_id"
                  name="agent_id"
                  :state="errors.length > 0 ? false : null"
                  :admin="true"
                  @onModelChange="(name,value) => form.agent_id = value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group :label="$t('Content')">
              <validation-provider
                #default="{ errors }"
                :name="$t('Content')"
                vid="content"
                rules="required"
              >
                <b-form-textarea
                  id="content"
                  v-model="form.content"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Content')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <attachments-form
              :form="attachmentsForm"
              :exists-attachments="form.attachments"
            />
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ isUpdated ? $t('Update') : $t("Send ticket") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'
import AttachmentsForm from '../../attachments/edit/AttachmentsForm'
import SelectUser from '../../core/edit/SelectUser.vue'

export default {
  name: 'TicketsEditModal',
  components: {
    SelectUser,
    AttachmentsForm,
  },
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'tickets',
      modalName: 'modal-tickets-edit',
      createAbleFields: [
        'subject',
        'category',
        'priority',
        'status',
        'user_id',
        'agent_id',
        'content',
      ],
    }
  },
}
</script>

<style scoped>

</style>
